/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactAddress } from './ContactAddress';
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
/**
 * Interface representing a contact document
 */
export type ContactDocument = {
    createdAt: string;
    updatedAt: string;
    metadata: any;
    tenantId: string;
    /**
     * @deprecated
     */
    email?: string | null;
    /**
     * @deprecated
     */
    phone?: string | null;
    providerId?: string | null;
    providerName?: string | null;
    customFields?: Dictionary_unknown_;
    addresses?: Array<ContactAddress>;
    nationalId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    companyPosition?: string | null;
    id: string;
    modelType: ContactDocument.modelType;
    archivedAt?: string | null;
    eventSequence?: number;
    eventTimestamp?: string;
    userId?: string | null;
    contactCompanyId?: string | null;
};
export namespace ContactDocument {
    export enum modelType {
        CONTACT = 'Contact',
    }
}

